import { SubPageTypes } from '../../types';
import { useSelector } from 'react-redux';
import { selectSingleObjectActiveTab } from '../../../../reducers/documentation/documentationReducer';
import { SelectedObjectHeader } from '../../selected-object/SelectedObjectHeader';
import { memo } from 'react';

interface HeaderRendererProps {
  pageType?: SubPageTypes;
  isExpandedMode: boolean;
  onCloseDialog?: () => void;
  hideAddObjectButton?: boolean;
}

export const HeaderRenderer = memo(
  ({ pageType, isExpandedMode, onCloseDialog, hideAddObjectButton }: HeaderRendererProps) => {
    const isObjectsScreen = pageType === SubPageTypes.objects;
    const activeTab = useSelector(selectSingleObjectActiveTab);

    if (isObjectsScreen && activeTab) {
      return (
        <SelectedObjectHeader
          hideAddObjectButton={hideAddObjectButton}
          onCloseDialog={onCloseDialog}
          isExpandedMode={isExpandedMode}
        />
      );
    }

    return null;
  },
);
